<div class="contextmenu" [ngStyle]="{'left.px': x, 'top.px': y}">
    <div *ngFor="let obj of menuList" (click)="employeeActivity(obj)">
        <img src="../../../../assets/Images/activity.png" style="width:18px;height:13px;padding-right:3px;">{{obj.menu}}
    </div>
</div>

